export default "__VITE_ASSET__Czjth7Xe__"